import { useState, useEffect, useContext } from 'react';
import { UserContext } from 'components/App';
import { getMenuItems, getWidgetsMenuItems, getExpandedMenuItemsForSuperUsers } from 'services/wall/navigation';
import { useSuperUsersMainRoutes } from './useSuperUsersMainRoutes';
import { useUserRole } from 'hooks/user/useUserRole';
import { hasAtLeastSuperRole } from 'services/security/accessServices';
import { useWallSelection } from 'hooks/wall/useWallSelection';

export const useNavItems = () => {
  const isSuperUserMainRoute = useSuperUsersMainRoutes();
  const [menuItems, setMenuItems] = useState({ wall: [], widgets: [] });
  const { selectedPlatform } = useWallSelection();
  const userRole = useUserRole();
  const { userData } = useContext(UserContext);
  const navigationRole = hasAtLeastSuperRole(userData?.highestRole) ? userData.highestRole : userRole;

  useEffect(() => {
    const expandMenu = hasAtLeastSuperRole(userRole) && !isSuperUserMainRoute;
    setMenuItems({
      wall: getMenuItems(navigationRole, selectedPlatform),
      widgets: getWidgetsMenuItems(userRole)
    });
  }, [userRole, navigationRole, isSuperUserMainRoute, selectedPlatform.hierarchicType, selectedPlatform]);

  return menuItems;
};
